(function () {
  'use strict';

  if (window.__DL_DRAWER_RECOS_ATC__) return;
  window.__DL_DRAWER_RECOS_ATC__ = true;

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  async function addToCartWithSections(variantId) {
    const payload = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: SECTIONS,
      sections_url: window.location.pathname
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const data = await res.json();
    if (!res.ok) throw data;
    return data; // includes sections HTML
  }

  function refreshDawnUI(data) {
    // Dawn’s cart-drawer listens for renderContents with sections HTML
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
    } else {
      // fallback minimal
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'drawer-recos' });
        }
      } catch (e) {}
    }

    // extra events (harmless)
    try { document.dispatchEvent(new CustomEvent('cart:change')); } catch(e){}
    try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch(e){}
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.drawer-reco-add-btn');
    if (!btn) return;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    if (btn.dataset.loading === 'true') return;
    btn.dataset.loading = 'true';

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '✓';

    try {
      const data = await addToCartWithSections(variantId);
      refreshDawnUI(data);
    } catch (err) {
      console.error('Drawer recos add failed:', err);
      btn.textContent = originalText;
      alert('Nu s-a putut adăuga produsul. Încearcă din nou.');
    } finally {
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.dataset.loading = 'false';
      }, 900);
    }
  });
})();